export default __webpack_public_path__ + "images/fire-x5Vrq.jpeg";